import { render, staticRenderFns } from "./product-suppliers.vue?vue&type=template&id=d45ff95e&scoped=true"
import script from "./product-suppliers.vue?vue&type=script&lang=js"
export * from "./product-suppliers.vue?vue&type=script&lang=js"
import style0 from "./product-suppliers.vue?vue&type=style&index=0&id=d45ff95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45ff95e",
  null
  
)

export default component.exports